import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';
import {
  formatNotificationUpdatedAt,
  getNotificationReasonBadgeVariant,
  getNotificationReasonLabel,
  getStockModeLabel,
} from '../../utils/notificationReason';
import '../Glass/ProcureModalStyle.css';
import '../Glass/GlassStyle.css';

/**
 * Detail modal for a single order reorder notification.
 * Shows stock vs threshold, stock mode, and order history statistics.
 */
const NotificationDetailModal = ({
  show,
  onHide,
  notification,
  detail,
  loading,
}) => {
  const product = detail?.product || notification?.product;
  const statistics = product?.statistics || {};
  const reason = notification?.reason || detail?.reason;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="procure-modal-glass procure-modal-glass-form"
    >
      <Modal.Header closeButton className="procure-modal__header">
        <Modal.Title>Reorder alert details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="procure-modal__body">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" role="status" aria-hidden="true" />
          </div>
        ) : (
          <>
            <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
              <Badge bg={getNotificationReasonBadgeVariant(reason)}>
                {getNotificationReasonLabel(reason)}
              </Badge>
              {notification?.updated_at ? (
                <span className="text-muted small">
                  Updated {formatNotificationUpdatedAt(notification.updated_at)}
                </span>
              ) : null}
            </div>

            <div className="glass-table-wrap mb-3">
            <Table bordered size="sm" className="mb-0">
              <tbody>
                <tr>
                  <th scope="row">Product</th>
                  <td>{product?.name || '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Catalog number</th>
                  <td>{product?.cat_num || '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Supplier</th>
                  <td>{product?.supplier_name || '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Effective stock</th>
                  <td>{detail?.effective_stock ?? product?.current_stock ?? '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Reorder threshold</th>
                  <td>{detail?.reorder_threshold ?? '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Stock mode</th>
                  <td>{getStockModeLabel(detail?.stock_mode)}</td>
                </tr>
              </tbody>
            </Table>
            </div>

            <h6 className="mb-2">Order history</h6>
            <div className="glass-table-wrap">
            <Table bordered size="sm" className="mb-0">
              <tbody>
                <tr>
                  <th scope="row">Last ordered</th>
                  <td>{statistics.last_ordered ?? '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Average order interval</th>
                  <td>{statistics.avg_order_time ?? '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Average order quantity</th>
                  <td>{statistics.avg_order_quantity ?? '—'}</td>
                </tr>
                <tr>
                  <th scope="row">Order count</th>
                  <td>{statistics.order_count ?? '—'}</td>
                </tr>
              </tbody>
            </Table>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NotificationDetailModal;
